import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import config from "../config";
import { getAccessToken, refreshAccessToken } from "../authClient";

type RetriableRequest = InternalAxiosRequestConfig & { _retry?: boolean };

const apiClient = axios.create({
  baseURL: config.API_URL,
});

const redirectToLogin = () => {
  if (window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
};

apiClient.interceptors.request.use(async (request) => {
  const token = await getAccessToken();
  if (token) {
    request.headers.set("Authorization", `Bearer ${token}`);
  }
  return request;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const request = error.config as RetriableRequest | undefined;

    if (error.response?.status !== 401 || !request || request._retry) {
      return Promise.reject(error);
    }

    request._retry = true;

    const token = await refreshAccessToken();
    if (!token) {
      redirectToLogin();
      return Promise.reject(error);
    }

    request.headers.set("Authorization", `Bearer ${token}`);
    return apiClient(request);
  }
);

export default apiClient;
